import { Link } from 'react-router-dom';

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-background-200 text-foreground-700">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-cup-line text-lg"></i>
              </span>
              <span className="font-brand text-2xl text-foreground-950">牛奶动漫库</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              专注治愈系、日常番与萌系动画的补番目录，帮你把温馨冷门作和轻松搞笑番都收进收藏夹，告别找番焦虑。
            </p>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wide text-foreground-950">
              内容分类
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/category/healing" className="transition hover:text-primary-600">
                  治愈番推荐
                </Link>
              </li>
              <li>
                <Link to="/category/daily" className="transition hover:text-primary-600">
                  日常番合集
                </Link>
              </li>
              <li>
                <Link to="/category/daily" className="transition hover:text-primary-600">
                  萌系动画
                </Link>
              </li>
              <li>
                <Link to="/category/healing" className="transition hover:text-primary-600">
                  温馨冷门作
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-sm font-semibold uppercase tracking-wide text-foreground-950">
              快捷入口
            </h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="transition hover:text-primary-600">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-600">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition hover:text-primary-600">
                  联系方式
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row">
          <p>© {year} 牛奶动漫库 · 温馨补番，从这一杯开始</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-mail-line"></i>
            contact@milk-anime.example
          </p>
        </div>
      </div>
    </footer>
  );
}